import { render, staticRenderFns } from "./KycReminderExpired.vue?vue&type=template&id=29f8c728&scoped=true"
import script from "./KycReminderExpired.vue?vue&type=script&lang=js"
export * from "./KycReminderExpired.vue?vue&type=script&lang=js"
import style0 from "./KycReminderExpired.vue?vue&type=style&index=0&id=29f8c728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f8c728",
  null
  
)

export default component.exports